import React from "react"
import {Message} from 'semantic-ui-react';
import styled from 'styled-components';

const StyledWarningMessages = styled(Message)`
  width: 100%;

  &.ui.yellow.message {
    box-shadow: unset;
    border-radius: unset;
    white-space: pre-line;
  }

  &.ui.message>.close.icon {
    vertical-align: middle;
    top: auto;
  }
`;

interface DivWrapperProps extends React.HTMLAttributes<HTMLDivElement> {
  [key: string]: any
}

export class StyledWarningMessage extends React.Component<DivWrapperProps> {
  render() {
    const {children, ...rest} = this.props;
    return <StyledWarningMessages color='yellow' {...rest}>
      {children}
    </StyledWarningMessages>;
  }
}

export default StyledWarningMessage;
